<template>
  <div class="main-container">
    <h1>Assigned Chatbots</h1>

    <!-- <div id="buttons-div">
      <button @click="openModal" :disabled="isLoading" id="uploadButton">
        {{ isLoading ? "Processing..." : "Create a Chatbot" }}
      </button>
    </div> -->

    <div v-if="message" id="noRecordsMessage">{{ message }}</div>

    <div class="chatbot-cards">
      <div v-for="chatbot in chatbots" :key="chatbot.id" class="chatbot-card glass-card">
        <div class="card-header">
          <h3>{{ chatbot.name }}<span v-if="chatbot.is_trial === true || chatbot.is_trial === 1"> (Trial)</span></h3>
          <span class="chip">{{ chatbot.chatbot_type }}</span>
        </div>
        <p class="meta"><strong>Created:</strong> {{ this.formatDate(chatbot.createdDate) }}</p>
        <p class="meta"><strong>Updated:</strong> {{ this.formatDate(chatbot.updatedDate) }}</p>
      </div>
    </div>

    <!-- Modal -->
    <div v-if="isModalOpen" class="modal-overlay">
      <div class="modal">
        <!-- <h3>Chatbot Details</h3> -->
        <div class="container">
          <h2>Choose your plan</h2>
          <div class="pricing-grid">
            <div class="plan-card" :class="{ disabled: isTrialDisabled }"
              @click="!isTrialDisabled && this.selectPlan('Basic Chatbot - Trial')">
              <h3>Trial</h3>
              <p class="plan-price">Free Trial for 7 Days</p>
              <ul class="plan-features">
                <li> Get started with... </li>
                <li> <span class="material-icons plan-checkmark">check_circle</span> Up to 100 conversations per month
                </li>
                <li><span class="material-icons plan-checkmark">check_circle</span> Basic customisation options</li>
                <li><span class="material-icons plan-checkmark">check_circle</span> Community Support</li>
              </ul>
            </div>
            <div class="plan-card" @click="this.selectPlan('Basic Chatbot')">
              <h3>Basic</h3>
              <p class="plan-price">R999/month</p>
              <ul class="plan-features">
                <li> Get started with... </li>
                <li><span class="material-icons plan-checkmark">check_circle</span> Up to 1000 conversations per month
                </li>
                <li><span class="material-icons plan-checkmark">check_circle</span> Advanced customisation options</li>
                <li><span class="material-icons plan-checkmark">check_circle</span> Priority Support</li>
                <li><span class="material-icons plan-checkmark">check_circle</span> Integrations</li>
              </ul>
            </div>
            <div class="plan-card" @click="this.selectPlan('Pro Chatbot')">
              <h3>Pro</h3>
              <p class="plan-price">R3999/month</p>
              <ul class="plan-features">
                <li> Everthing in basic plus... </li>
                <li><span class="material-icons plan-checkmark">check_circle</span> Unlimited Conversations</li>
                <li><span class="material-icons plan-checkmark">check_circle</span> Full customisation options</li>
                <li><span class="material-icons plan-checkmark">check_circle</span> Dedicated Support</li>
                <li><span class="material-icons plan-checkmark">check_circle</span> All Integrations</li>
                <li><span class="material-icons plan-checkmark">check_circle</span> Dedicated Account Management</li>
              </ul>
            </div>
          </div>
        </div>
        <form @submit.prevent="handleFormSubmit">
          <input type="text" v-model="formData.userId" placeholder="User ID" required hidden />

          <input type="text" v-model="formData.selectedPlan" placeholder="Selected Plan" required readonly disabled />

          <input type="text" v-model="formData.chatbotName" placeholder="Chatbot Name" required />

          <input type="email" v-model="formData.helpEmail" placeholder="Help Email" required />

          <input type="text" v-model="formData.company" placeholder="Company" required readonly disabled />

          <input type="url" v-model="formData.website" placeholder="Website" required />

          <div class="modal-actions">
            <button type="submit" class="pill-button accent">OK</button>
            <button type="button" @click="closeModal" class="pill-button ghost">Cancel</button>
          </div>
        </form>

      </div>
    </div>
  </div>
  <!-- Spinner overlay while loading -->
  <Spinner :show="isLoading" />
</template>

<script>
import axios from "axios";
import Spinner from "@/components/SpinnerComponent.vue";
import { fetchChatbots } from "@/services/fetchChatbotService"; // Import the service

export default {
  name: "ManageChatbotsPage",
  components: {
    Spinner,
  },
  data() {
    return {
      apiUrl: process.env.VUE_APP_MICROSERVICE_API_URL,
      user: null,
      isLoading: false,
      message: "",
      chatbots: [],
      isModalOpen: false,
      formData: {
        userId: "",
        selectedPlan: "",
        chatbotName: "",
        helpEmail: "",
        company: "",
        website: "",
        telephone: "",
        role: ""
      },
      isTrialDisabled: true,
    };
  },
  watch: {
    // Watch for changes in chatbots and recalculate
    chatbots: {
      immediate: true, // Trigger on component initialization
      handler(newVal) {
        this.isTrialDisabled = newVal.some(chatbot => chatbot.is_trial === true || chatbot.is_trial === 1);
        // console.log("newVal:", newVal);
        // console.log("isTrialDisabled:", this.isTrialDisabled);
      },
      deep: true
    },
  },
  created() {
    const userData = localStorage.getItem("customerRecord");
    // console.log("User Data:", userData);
    if (userData) {
      this.user = JSON.parse(userData);
    }
    this.loadChatbots();
    const chatbotData = localStorage.getItem("chatbotRecords");
    if (chatbotData) {
      this.chatbots = JSON.parse(chatbotData);
    }
    // console.log("Chatbot Data:", this.chatbots);

    this.formData.userId = this.user.id;
    this.formData.company = this.user.company;
    this.formData.website = this.user.company_website;
    this.formData.helpEmail = this.user.email;

    // console.log("TrailDisabled:", this.isTrialDisabled);
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      if (isNaN(date)) return dateString; // if invalid date, return original string
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}-${month}-${year} ${hours}:${minutes}`;
    },
    selectPlan(plan) {
      this.formData.selectedPlan = plan;
    },
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    async handleFormSubmit() {
      try {
        console.log(this.formData);
        await this.sendToRagbot(); // Add chatbot via API
        await this.loadChatbots(); // Refresh chatbot list
      } catch (error) {
        console.error('Error adding chatbot:', error);
      } finally {
        this.closeModal(); // Close modal regardless of success
      }
    },
    async sendToRagbot() {
      if (!this.user) {
        this.message = "User data not available. Please log in.";
        return;
      }

      this.message = "";
      this.isLoading = true;

      try {
        const response = await axios.post(
          `${this.apiUrl}/chatbots`,
          {
            id: this.user.id,
            name: this.user.company,
            email: this.formData.helpEmail,
            chatbot_name: this.formData.chatbotName,
            website: this.formData.website,
            selected_plan: this.formData.selectedPlan,
            is_trial: this.formData.selectedPlan === 'Basic Chatbot - Trial' ? 1 : 0
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        this.message = "Data successfully sent to Create a basic Chatbot!";
        console.log("API Response:", response.data);
        await this.loadChatbots();
      } catch (error) {
        this.message =
          error.response?.data?.message || "An error occurred while sending data.";
        console.error("API Error:", error);
        await this.loadChatbots();
      } finally {
        this.isLoading = false;
        await this.loadChatbots();
      }
    },
    async loadChatbots() {
      this.isLoading = true;
      try {
        const userId = localStorage.getItem("userId");
        const chatbots = await fetchChatbots(userId);
        this.chatbots = chatbots;
        // console.log(chatbots);
      } catch (error) {
        console.error('Failed to load chatbots:', error);
      } finally {
        this.isLoading = false;
      }
    }
  },
};
</script>

<style scoped>
.main-container {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px;
  color: var(--text-primary);
}

h1 {
  font-size: 2rem;
  color: var(--text-primary);
  margin-bottom: 1rem;
  text-align: center;
}

#noRecordsMessage {
  margin-top: 20px;
  text-align: center;
  color: var(--text-secondary);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
}

.modal {
  background: linear-gradient(180deg, rgba(17, 24, 39, 0.92) 0%, rgba(12, 18, 30, 0.96) 100%);
  padding: 24px;
  border-radius: var(--radius-2xl);
  box-shadow: var(--shadow-card);
  width: min(840px, 100%);
  font-size: 1rem;
  border: 1px solid var(--border-color);
  backdrop-filter: blur(12px);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  padding: 0 10px;
  margin-bottom: 1.5rem;
}

.plan-card {
  padding: 20px;
  background: var(--bg-glass);
  border-radius: var(--radius-2xl);
  line-height: 1.4;
  box-shadow: var(--shadow-card);
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
  border: 1px solid var(--border-color);
  cursor: pointer;
}


.plan-card:hover {
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.55);
  border-color: rgba(255, 255, 255, 0.12);
}

.chatbot-cards {
  display: grid;
  gap: 16px;
}

.chatbot-card {
  padding: 16px;
  border-radius: var(--radius-2xl);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-card);
  backdrop-filter: blur(10px);
  color: var(--text-primary);
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.card-header h3 {
  margin: 0;
}

.chip {
  padding: 6px 10px;
  border-radius: var(--radius-pill);
  background: var(--bg-glass-strong);
  border: 1px solid var(--border-color);
  font-size: 12px;
  color: var(--text-secondary);
}

.meta {
  margin: 4px 0;
  color: var(--text-secondary);
}

.plan-card.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.plan-price {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: var(--accent-orange);
}

.plan-features {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
  padding: 0 8px 0 0;
  list-style: none;
  gap: 8px 12px;
}

.plan-features li {
  margin: 0;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.95rem;
  width: 100%;
}

.plan-checkmark {
  font-size: 1rem;
  background: linear-gradient(90deg, var(--accent-orange) 0%, var(--accent-orange-hover) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.plan-checkmark.plan-cross {
  background: none;
  -webkit-text-fill-color: var(--text-secondary);
}

form {
  display: grid;
  gap: 10px;
  margin-top: 12px;
}

input::placeholder {
  color: var(--text-secondary);
}

input {
  padding: 10px;
  margin-bottom: 10px;
  width: 100%;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-xl);
  font-size: 0.95rem;
  background: var(--bg-glass);
  color: var(--text-primary);
}

input:focus {
  border-color: rgba(249, 115, 22, 0.6);
  outline: none;
  box-shadow: var(--focus-ring);
}

#plan a {
  color: gray;
  text-decoration: none;
}

#plan a:hover {
  color: rgb(250, 90, 6);
}
</style>
